import axios from "axios";

// ✅ Sirf .env se URL lega, koi fallback nahi
const API_BASE_URL = process.env.REACT_APP_API_URL;

/* ================= GET CART ================= */
export const getCartByUserId = async (userId) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}MasterAPI/GetCartByUserId?userId=${userId}`
    );

    const raw = res?.data?.data?.[0];

    if (!raw || !raw.itemsJson) {
      return { cartId: 0, items: [] };
    }

    let parsedItems = [];

    try {
      parsedItems =
        typeof raw.itemsJson === "string"
          ? JSON.parse(raw.itemsJson)
          : raw.itemsJson || [];
    } catch (e) {
      console.error("JSON PARSE ERROR:", e);
      parsedItems = [];
    }

    const items = parsedItems.map((i) => {
      const price = Number(i.Price ?? i.price ?? i.SellingPrice ?? i.sellingPrice ?? 0);
      const originalPrice = Number(
        i.OriginalPrice ?? i.originalPrice ?? i.MRP ?? i.Mrp ?? i.mrp ?? i.TestPrice ?? i.testPrice ?? i.PackagePrice ?? i.packagePrice ?? 0
      );
      const discount = Number(i.Discount ?? i.discount ?? i.DiscountAmount ?? i.discountAmount ?? 0);
      const discountPercent = Number(i.DiscountPercent ?? i.discountPercent ?? i.DiscountPercentage ?? i.discountPercentage ?? 0);

      let finalOriginalPrice = originalPrice;
      if (!finalOriginalPrice || finalOriginalPrice <= price) {
        if (discount > 0) {
          finalOriginalPrice = price + discount;
        } else if (discountPercent > 0) {
          finalOriginalPrice = Math.round((price * 100) / (100 - discountPercent));
        } else {
          // Standard estimate if originalPrice not passed
          finalOriginalPrice = Math.round(price * 1.35);
        }
      }

      return {
        productId: Number(i.ProductId ?? i.productId),
        categoryId: Number(i.CategoryId ?? i.categoryId),
        name: i.ItemName || i.name || i.Name || "Diagnostic Test",
        quantity: Number(i.TotalQuantity ?? i.quantity ?? 1),
        price: price,
        originalPrice: finalOriginalPrice > price ? finalOriginalPrice : null,
        discount: discount > 0 ? discount : (finalOriginalPrice > price ? finalOriginalPrice - price : 0),
        discountPercent: discountPercent > 0 ? discountPercent : (finalOriginalPrice > price ? Math.round(((finalOriginalPrice - price) / finalOriginalPrice) * 100) : 0),
        totalPrice: Number(i.TotalPrice ?? (price * (Number(i.TotalQuantity ?? i.quantity ?? 1)))),
        storeId: Number(i.StoreId ?? i.storeId ?? 0),
        image: i.Image || i.image || "",
      };
    });

    return {
      cartId: raw.cartId,
      items,
    };
  } catch (err) {
    console.error("GET CART ERROR:", err);
    return { cartId: 0, items: [] };
  }
};

/* ================= ADD / REMOVE CART ================= */
export const updateCartOnServer = async (payload) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}MasterAPI/AddToCart`,
      {
        userId: payload.userId,
        productId: Number(payload.productId),
        categoryId: Number(payload.categoryId),
        totalQuantity: Number(payload.totalQuantity),
        price: Number(payload.price || 0),
        discount: Number(payload.discount || 0),
        coupon: payload.coupon || "",
      }
    );

    return res.data;
  } catch (err) {
    console.error("UPDATE CART ERROR:", err);
    return { succeeded: false };
  }
};

/* ================= DELETE CART ================= */
export const deleteCartOnServer = async (cartId) => {
  try {
    console.log("📡 DELETE API HIT");

    const res = await axios.post(
      `${API_BASE_URL}MasterAPI/DeleteCart`,
      {
        cardId: Number(cartId),
      }
    );

    console.log("🟢 DELETE RESPONSE:", res.data);

    return res.data;
  } catch (err) {
    console.error("❌ DELETE API ERROR:", err);
    return { succeeded: false };
  }
};